export interface QuizQuestion {
  id: string;
  question: string;
  options: string[];
  correctAnswer: number;
  difficulty: 'easy' | 'medium' | 'hard';
  category: 'symbols' | 'properties' | 'categories' | 'isotopes' | 'general';
  explanation?: string;
}

export const quizQuestions: QuizQuestion[] = [
  // Easy - Symbols
  {
    id: 'q1',
    question: 'Quel est le symbole chimique de l\'hydrogène ?',
    options: ['Hy', 'H', 'Hd', 'Hr'],
    correctAnswer: 1,
    difficulty: 'easy',
    category: 'symbols',
    explanation: 'L\'hydrogène est le premier élément du tableau périodique avec le symbole H.',
  },
  {
    id: 'q2',
    question: 'Quel élément a le symbole "O" ?',
    options: ['Or', 'Osmium', 'Oxygène', 'Oganesson'],
    correctAnswer: 2,
    difficulty: 'easy',
    category: 'symbols',
  },
  {
    id: 'q3',
    question: 'Quel est le symbole chimique de l\'or ?',
    options: ['Or', 'Au', 'Ag', 'Go'],
    correctAnswer: 1,
    difficulty: 'easy',
    category: 'symbols',
    explanation: 'L\'or a le symbole Au, dérivé du latin "aurum".',
  },
  {
    id: 'q4',
    question: 'Quel élément a le symbole "Fe" ?',
    options: ['Fluor', 'Fer', 'Fermium', 'Francium'],
    correctAnswer: 1,
    difficulty: 'easy',
    category: 'symbols',
  },
  {
    id: 'q5',
    question: 'Quel est le symbole chimique du sodium ?',
    options: ['So', 'Sd', 'Na', 'S'],
    correctAnswer: 2,
    difficulty: 'easy',
    category: 'symbols',
    explanation: 'Le sodium a le symbole Na, dérivé du latin "natrium".',
  },

  // Medium - Properties
  {
    id: 'q6',
    question: 'Quel est le numéro atomique du carbone ?',
    options: ['4', '6', '8', '12'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'properties',
    explanation: 'Le carbone a 6 protons, donc son numéro atomique est 6.',
  },
  {
    id: 'q7',
    question: 'Quel élément est le plus électronégatif ?',
    options: ['Oxygène', 'Fluor', 'Chlore', 'Azote'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'properties',
  },
  {
    id: 'q8',
    question: 'Quel est l\'état physique du mercure à température ambiante ?',
    options: ['Solide', 'Liquide', 'Gaz', 'Plasma'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'properties',
  },
  {
    id: 'q9',
    question: 'Quelle est la configuration électronique de l\'hélium ?',
    options: ['1s¹', '1s²', '2s²', '1s² 2s¹'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'properties',
  },
  {
    id: 'q10',
    question: 'Quel élément a la masse atomique la plus élevée naturellement présent ?',
    options: ['Uranium', 'Plutonium', 'Thorium', 'Radium'],
    correctAnswer: 0,
    difficulty: 'medium',
    category: 'properties',
  },

  // Medium - Categories
  {
    id: 'q11',
    question: 'Quel élément est un gaz noble ?',
    options: ['Sodium', 'Néon', 'Soufre', 'Silicium'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'categories',
  },
  {
    id: 'q12',
    question: 'Combien y a-t-il de lanthanides dans le tableau périodique ?',
    options: ['14', '15', '16', '17'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'categories',
  },
  {
    id: 'q13',
    question: 'Quel élément est un halogène ?',
    options: ['Magnésium', 'Manganèse', 'Brome', 'Bore'],
    correctAnswer: 2,
    difficulty: 'medium',
    category: 'categories',
  },
  {
    id: 'q14',
    question: 'Les métaux alcalins se trouvent dans quelle colonne ?',
    options: ['Colonne 1', 'Colonne 2', 'Colonne 17', 'Colonne 18'],
    correctAnswer: 0,
    difficulty: 'medium',
    category: 'categories',
  },
  {
    id: 'q15',
    question: 'Quel élément est un métalloïde ?',
    options: ['Aluminium', 'Silicium', 'Phosphore', 'Soufre'],
    correctAnswer: 1,
    difficulty: 'medium',
    category: 'categories',
  },

  // Hard - Isotopes
  {
    id: 'q16',
    question: 'Quel isotope de l\'uranium est utilisé dans les centrales nucléaires ?',
    options: ['Uranium-235', 'Uranium-238', 'Uranium-234', 'Uranium-233'],
    correctAnswer: 0,
    difficulty: 'hard',
    category: 'isotopes',
  },
  {
    id: 'q17',
    question: 'Le carbone-14 est utilisé pour la datation. Quel est son type de désintégration ?',
    options: ['Alpha', 'Bêta-', 'Bêta+', 'Gamma'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'isotopes',
  },
  {
    id: 'q18',
    question: 'Combien de neutrons y a-t-il dans un atome de carbone-12 ?',
    options: ['6', '12', '18', '14'],
    correctAnswer: 0,
    difficulty: 'hard',
    category: 'isotopes',
  },
  {
    id: 'q19',
    question: 'Quel isotope de l\'hydrogène est appelé deutérium ?',
    options: ['Hydrogène-1', 'Hydrogène-2', 'Hydrogène-3', 'Hydrogène-4'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'isotopes',
  },
  {
    id: 'q20',
    question: 'Quel type de rayonnement est émis lors de la désintégration alpha ?',
    options: ['Électrons', 'Noyaux d\'hélium', 'Photons', 'Neutrons'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'isotopes',
  },

  // Easy - General
  {
    id: 'q21',
    question: 'Combien d\'éléments y a-t-il dans le tableau périodique moderne ?',
    options: ['92', '103', '118', '120'],
    correctAnswer: 2,
    difficulty: 'easy',
    category: 'general',
  },
  {
    id: 'q22',
    question: 'Qui a créé le premier tableau périodique ?',
    options: ['Marie Curie', 'Dmitri Mendeleïev', 'Albert Einstein', 'Antoine Lavoisier'],
    correctAnswer: 1,
    difficulty: 'easy',
    category: 'general',
  },
  {
    id: 'q23',
    question: 'Quel élément est essentiel à la respiration ?',
    options: ['Azote', 'Oxygène', 'Hydrogène', 'Carbone'],
    correctAnswer: 1,
    difficulty: 'easy',
    category: 'general',
  },
  {
    id: 'q24',
    question: 'Quel élément compose la majorité de l\'atmosphère terrestre ?',
    options: ['Oxygène', 'Hydrogène', 'Azote', 'Argon'],
    correctAnswer: 2,
    difficulty: 'easy',
    category: 'general',
  },
  {
    id: 'q25',
    question: 'Quel élément donne la couleur rouge aux feux d\'artifice ?',
    options: ['Strontium', 'Baryum', 'Cuivre', 'Sodium'],
    correctAnswer: 0,
    difficulty: 'medium',
    category: 'general',
  },

  // Hard - General
  {
    id: 'q26',
    question: 'Quel élément a été découvert dans le Soleil avant d\'être trouvé sur Terre ?',
    options: ['Uranium', 'Hélium', 'Plutonium', 'Radium'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'general',
  },
  {
    id: 'q27',
    question: 'Quel est l\'élément le plus rare naturellement sur Terre ?',
    options: ['Astate', 'Francium', 'Technétium', 'Prométhium'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'general',
  },
  {
    id: 'q28',
    question: 'Quel élément a la conductivité thermique la plus élevée ?',
    options: ['Cuivre', 'Argent', 'Or', 'Diamant (carbone)'],
    correctAnswer: 3,
    difficulty: 'hard',
    category: 'properties',
  },
  {
    id: 'q29',
    question: 'Combien d\'électrons peut contenir la couche électronique M ?',
    options: ['2', '8', '18', '32'],
    correctAnswer: 2,
    difficulty: 'hard',
    category: 'properties',
  },
  {
    id: 'q30',
    question: 'Quel élément a le point de fusion le plus bas ?',
    options: ['Mercure', 'Hélium', 'Hydrogène', 'Azote'],
    correctAnswer: 1,
    difficulty: 'hard',
    category: 'properties',
  },
];

export function getRandomQuestions(count: number, difficulty?: 'easy' | 'medium' | 'hard'): QuizQuestion[] {
  let filteredQuestions = quizQuestions;

  if (difficulty) {
    filteredQuestions = quizQuestions.filter(q => q.difficulty === difficulty);
  }

  const shuffled = [...filteredQuestions].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export function getQuestionsByCategory(category: QuizQuestion['category']): QuizQuestion[] {
  return quizQuestions.filter(q => q.category === category);
}
